document.addEventListener("DOMContentLoaded", function () {
    const drawerMappings = [
        { trigger: "guideTaille", drawer: "taille-drawer" },
        { trigger: "details", drawer: "details-drawer" },
        { trigger: "livraison", drawer: "livraison-drawer" },
        { trigger: "couleurs", drawer: "couleurs-drawer" },
        { trigger: "pierres", drawer: "pierres-drawer" },
        { trigger: "select", drawer: "select-drawer" },
        { trigger: "gravure", drawer: "gravure-drawer" }
    ];

    drawerMappings.forEach(function (mapping) {
        const triggerElement = document.querySelector(`.${mapping.trigger}`);
        const drawerSelector = `.${mapping.drawer}`;

        if (triggerElement) {
            triggerElement.addEventListener("click", function () {
                document.body.classList.add("no-scroll");
                const drawer = document.querySelector(drawerSelector);
                if (drawer) {
                    const translate = drawer.querySelector(".toTranslate");
                    const toOpacityOverlay = drawer.querySelector(".toOpacity");
                    if (translate && toOpacityOverlay) {
                        translate.classList.toggle("translate-x-full");
                        drawer.classList.toggle("invisible");
                        toOpacityOverlay.classList.toggle("opacity-30");
                    }
                }
            });

            const drawer = document.querySelector(drawerSelector);
            if (drawer) {
                const closeBtns = drawer.querySelectorAll(".close");
                closeBtns.forEach(function (closeBtn) {
                    closeBtn.addEventListener("click", function () {
                        document.body.classList.remove("no-scroll");
                        const translate = drawer.querySelector(".toTranslate");
                        const toOpacityOverlay = drawer.querySelector(".toOpacity");
                        if (translate && toOpacityOverlay) {
                            translate.classList.toggle("translate-x-full");
                            drawer.classList.toggle("invisible");
                            toOpacityOverlay.classList.toggle("opacity-30");
                        }
                    });
                });
            }
        }
    });

    // Handle size selection
    const sizes = document.querySelectorAll('.variant');
    sizes.forEach(size => {
        size.addEventListener('click', function () {
            const innerHTML = this.querySelector('.title').innerHTML;
            const variantTitle = this.dataset.title;
            const writeDiv = document.querySelector('.write');
            if (writeDiv) {
                writeDiv.innerHTML = innerHTML;



                const productForms = document.querySelectorAll(
                    `#variant-selects-${this.dataset.section}`
                );
                productForms.forEach(form => {
                    const radioInput = form.querySelector(`input[type="radio"][value="${variantTitle}"]`);
                    if (radioInput) {
                        radioInput.checked = true;
                        radioInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });//+



            }
        });
    });

    // Handle gravure input
    const gravureInput = document.querySelector('.gravureInput');
    const gravureHidden = document.querySelector('.gravureHidden');
    const gravureField = document.getElementById('custom_gravure');
    const gravureShown = document.querySelector('.gravureShown');
    const gravureText = document.querySelector('.gravureText');
    if (gravureText) {


        const gravureTextContent = gravureText.textContent;
        const gravureShown2 = document.querySelector('.gravureShown2');
        const gravureReset = document.querySelector('.gravureReset');

        if (gravureInput && gravureField) {
            gravureInput.value = '';
            gravureField.value = '';

            gravureShown.addEventListener('click', function () {
                const gravureValue = gravureInput.value;
                gravureField.value = gravureValue;
                gravureText.textContent = gravureValue;
                setTimeout(function () {
                    gravureHidden.classList.toggle('hidden');
                    gravureHidden.classList.add('flex');
                    gravureShown.classList.toggle('hidden');
                }, 1000);
            });

            gravureShown2.addEventListener('click', function () {
                const gravureValue = gravureInput.value;
                gravureField.value = gravureValue;
                gravureText.textContent = gravureValue;
            });

            gravureReset.addEventListener('click', function () {
                gravureInput.value = '';
                gravureField.value = '';
                gravureText.textContent = gravureTextContent;
                gravureHidden.classList.toggle('hidden');
                gravureShown.classList.toggle('hidden');
            });
        }
    }
});
